import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from '../app/base-query-with-reauth'

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  tagTypes: [
    'Alerts',
    'AppSettings',
    'AppSettingsHistory',
    'Chats',
    'ChatMessages',
    'Workspaces',
    'Sagas',
    'Users',
    'Members',
    'WorkspaceMembersOptions',
    'WorkspacesOptions',
    'Spaces',
    'SpaceMembers',
    'CurrentSpaceMember',
    'SpaceMemberInterests',
    'SpaceAIPlugin',
    'SpacePluginToken',
    'SingleSpace',
    'MemberStatus',
    'MemberAnswers',
    'MemberSystemAnswers',
    'Feedback',
    'Starters',
    'AppProducts',
    'AnalyzedChats',
    'PersonalizedStarters',
    'InductionQuestions',
    'Flows',
    'InductionQuestionsCategories',
    'Tools',
    'AiFlow',
    'SystemTools',
    'LearnerDiagram',
    'Interviews',
    'LearnerEngagement',
    'Changelogs',
    'ChangelogUnread',
    'ChangelogUserReadAudit',
    'StudentPlanSection'
  ]
})
